import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { Box } from '@web/components/atoms/Layout'
import { LexicalEditor } from 'lexical'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { ListItemNode, ListNode } from '@lexical/list'
import { AutoLinkNode, LinkNode } from '@lexical/link'
import { MergeTagNode } from './MergeTags/MergeTagNode'
import { styles, theme } from './theme'
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { AutoLinkPlugin, createLinkMatcherWithRegExp } from '@lexical/react/LexicalAutoLinkPlugin'

interface RichTextEditorComposerProps {
  initialEditorState?: string
  isEditable?: boolean
  children: React.ReactNode | React.ReactNode[]
}

const editorConfig = {
  namespace: 'page-editor',
  onError(error: Error, editor: LexicalEditor): void {
    throw error
  },
  nodes: [MergeTagNode, HeadingNode, AutoLinkNode, LinkNode, ListNode, ListItemNode, QuoteNode],
  theme,
}

const urlRegExp = new RegExp(
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,
)
export function validateUrl(url: string): boolean {
  return url === 'https://' || urlRegExp.test(url)
}

const AUTO_LINK_URL_REG_EXP =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/

const MATCHERS = [
  createLinkMatcherWithRegExp(AUTO_LINK_URL_REG_EXP, (text) => {
    return text
  }),
]

const RichTextEditorComposer = ({ initialEditorState, isEditable = true, children }: RichTextEditorComposerProps) => (
  <Box css={styles}>
    <LexicalComposer initialConfig={{ ...editorConfig, editorState: initialEditorState, editable: isEditable }}>
      {children}
      <LinkPlugin validateUrl={validateUrl} />
      <AutoLinkPlugin matchers={MATCHERS} />
    </LexicalComposer>
  </Box>
)

export default RichTextEditorComposer
